import { post } from "../../service/api";

const CreateAdminMerchant = async (body) => {
  try {
    return await post("/admin/merchant", body);
  } catch (error) {
    console.error("Error CreateAdminMerchant:", error);
    throw error;
  }
};

export default CreateAdminMerchant;
